<template>
  <div class='home'>
    <PriceListGroupList
      v-show='listView'
      @newPriceListGroup='onClickNewFromList'
      @editPriceListGroup='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <PriceListGroupForm
      v-show='formView'
      :priceListGroup='priceListGroup'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import PriceListGroupList from '@/components/price-list-group/PriceListGroupList.vue'
import PriceListGroupForm from '@/components/price-list-group/PriceListGroupForm.vue'

export default {
  name: 'Price_List_Group',
  components: {
    PriceListGroupList,
    PriceListGroupForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      priceListGroup: {
        id: null,
        name: null,
        price_date: null,
        description: null,
        lists: [{
          id: null,
          group_id: null,
          product_no: null,
          quantity: null,
          price: null,
          start_date: null,
          end_date: null,
          uom_id: null
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.priceListGroup = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.priceListGroup = {
        id: null,
        name: null,
        price_date: null,
        description: null,
        lists: [{
          group_id: null,
          product_no: null,
          quantity: null,
          price: null,
          start_date: null,
          end_date: null,
          uom_id: null
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.priceListGroup = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getProductList')
    this.$store.dispatch('getUomList')
  }
}
</script>
